import React from 'react';
import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer } from 'recharts';

const DepartmentExpirationChart = ({ data }) => {
  if (!data || data?.length === 0) {
    return null;
  }

  return (
    <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-6">
      <h3 className="text-lg font-semibold text-gray-900 mb-4">Expirations by Department</h3>
      <ResponsiveContainer width="100%" height={300}>
        <BarChart data={data}>
          <CartesianGrid strokeDasharray="3 3" />
          <XAxis dataKey="department" />
          <YAxis />
          <Tooltip />
          <Legend />
          <Bar dataKey="expired" fill="#ef4444" name="Expired" />
          <Bar dataKey="critical" fill="#f97316" name="Critical" />
          <Bar dataKey="warning" fill="#eab308" name="Warning" />
          <Bar dataKey="upcoming" fill="#3b82f6" name="Upcoming" />
          <Bar dataKey="valid" fill="#10b981" name="Valid" />
        </BarChart>
      </ResponsiveContainer>
    </div>
  );
};

export default DepartmentExpirationChart;